'use client';
import { getImageUrl, sendRequest } from '@/lib/api-service';
import Image from 'next/image';
import { useState, useEffect } from 'react';
import { FaMapMarkerAlt, FaPhoneAlt, FaEnvelope, FaFacebook, FaInstagram, FaYoutube } from 'react-icons/fa';

export default function Page() {
	const [headerImage, setHeaderImage] = useState<string|null>(null);
	useEffect(() => {
		
		const fetchDynamicImages = async () => {
			const response = await sendRequest('POST', '/dynamic-images/', {codes:["contact"]}, true);
			if (response && Array.isArray(response)) {
				const joinImg = response.find((img: { code: string }) => img.code === "contact");
				if (joinImg && joinImg.image) setHeaderImage(joinImg.image);
			}
		};
		fetchDynamicImages();
	}, []);


	return (
		<div className="bg-white max-w-[1920px] mx-auto">
			<div className="relative w-full h-[40vh]">
				{headerImage && (
					<Image
						src={getImageUrl(headerImage)}
						alt="Who we are"
						fill
						className="object-cover"
					/>
				)}
				<div className="absolute inset-0 bg-black/10 flex items-center justify-center">
					<h1 className="text-4xl md:text-6xl font-bold mb-4 drop-shadow-md header text-transparent bg-clip-text bg-gradient-to-b from-fire-500 to-fire-900 uppercase px-4 text-center">
						Бидэнтэй холбогдох
					</h1>
				</div>
				<div
					className="w-full h-[20vh] opacity-25 bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/1.svg')" }}
				/>
				<div
					className="w-full h-[20vh] opacity-25 bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/2.svg')" }}
				/>
				<div
					className="w-full h-[20vh] opacity-25  bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/3.svg')" }}
				/>
				<div
					className="w-full h-[30vh]  bg-no-repeat bg-top bg-cover absolute bottom-0"
					style={{ backgroundImage: "url('/waves/low.svg')" }}
				/>
			</div>

			{/* Contact Details Section */}
			<div className="max-w-[400px] px-5 mx-auto py-20 bg-white">
				<div className="space-y-8">
					{/* Address Section */}
					<div className="space-y-4">
						<h3 className="text-2xl font-semibold text-center">Бидний хаяг</h3>
						<p className="flex items-start gap-2 text-xl">
							<FaMapMarkerAlt className="text-mountain-600 mt-1" />
							<span>
								Төв оффис:<br />
								ЧД, 5-р хороо, Самбуугийн гудамж 21/1<br />
								(Тэнгис кино театрын баруун талд)
							</span>

						</p>

						<p className="flex items-start gap-2 text-xl">
							<FaMapMarkerAlt className="text-mountain-600 mt-1" />
							<span>
								Зуслан:<br />
								СХД, 24-р хороо, Баруун салаа, Баянсогоотын ам
							</span>

						</p>

					</div>

					{/* Contact Section */}
					<div className="space-y-4">
						<h3 className="text-2xl font-semibold text-center">Бидэнтэй холбогдох</h3>
						<p className="flex items-center gap-2 text-xl">
							<FaPhoneAlt className="text-mountain-600" />
							<a href="tel:+97699096109" className="hover:underline">+976 99096109</a>
						</p>
						<p className="flex items-center gap-2 text-xl">
							<FaPhoneAlt className="text-mountain-600" />
							<a href="tel:+97611325329" className="hover:underline">+976 11325329</a>
						</p>
						<p className="flex items-center gap-2 text-xl">
							<FaEnvelope className="text-mountain-600" />
							<a href="mailto:office@narscamp.mn" className="hover:underline">office@narscamp.mn</a>
						</p>
					</div>

					{/* Social Media Section */}
					<div className="space-y-4 text-center">
						<h3 className="text-2xl font-semibold">Биднийг дагаарай</h3>
						<div className="flex space-x-4 justify-center">
							<a href="https://www.facebook.com/narssummercamp?mibextid=LQQJ4d" target="_blank" rel="noopener noreferrer" className="text-3xl p-4 rounded-sm text-white bg-ash-500 hover:bg-blue-500">
								<FaFacebook />
							</a>
							<a href="https://www.instagram.com/narscamp.mongolia/" target="_blank" rel="noopener noreferrer" className="text-3xl p-4 rounded-sm text-white bg-ash-500 hover:bg-pink-500">
								<FaInstagram />
							</a>
							<a href="https://www.youtube.com/@narschildrenscamp9739" target="_blank" rel="noopener noreferrer" className="text-3xl p-4 rounded-sm text-white bg-ash-500 hover:bg-red-500">
								<FaYoutube />
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
